import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FeeForm = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        email: '',
        phone: '',
        consent: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log("Form data submitted:", formData);
        alert("Form submitted (see console for data). Implement actual submission logic.");
    };

    return (
        // The original form had `style="display: none;"` initially, likely shown by JS.
        // In React, we control visibility with state if needed, but here we'll show it directly.
        <form
            id="forminator-module-42-react" // Changed ID to avoid conflict if original JS is still around
            className="forminator-ui forminator-custom-form forminator-custom-form-42 forminator-design--default forminator_ajax"
            method="post"
            onSubmit={handleSubmit}
            data-forminator-render="1" // Mark as rendered
            data-form-id="42"
            data-design="default"
            data-grid="open"
        >
            {/* Hidden messages div for potential errors - manage with React state */}
            {/* <div role="alert" aria-live="polite" className="forminator-response-message forminator-error" aria-hidden="true"></div> */}

            <div className="forminator-row">
                <div id="name-1" className="forminator-field-name forminator-col forminator-col-6">
                    <div className="forminator-field">
                        <label htmlFor="forminator-field-name-1_react" className="forminator-label">
                            First Name <span className="forminator-required">*</span>
                        </label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            placeholder="E.g. John"
                            id="forminator-field-name-1_react"
                            className="forminator-input forminator-name--field"
                            aria-required="true"
                            required
                        />
                    </div>
                </div>
                <div id="email-1" className="forminator-field-email forminator-col forminator-col-6">
                    <div className="forminator-field">
                        <label htmlFor="forminator-field-email-1_react" className="forminator-label">
                            Email Address <span className="forminator-required">*</span>
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="E.g. john@doe.com"
                            id="forminator-field-email-1_react"
                            className="forminator-input forminator-email--field"
                            data-required="true"
                            aria-required="true"
                            required
                        />
                    </div>
                </div>
            </div>
            <div className="forminator-row">
                <div id="phone-1" className="forminator-field-phone forminator-col forminator-col-12">
                    <div className="forminator-field">
                        <label htmlFor="forminator-field-phone-1_react" className="forminator-label">Phone Number</label>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="E.g. +1 3004005000"
                            id="forminator-field-phone-1_react"
                            className="forminator-input forminator-field--phone"
                            autoComplete="off"
                        />
                    </div>
                </div>
            </div>
            <div className="forminator-row">
                <div id="consent-1" className="forminator-field-consent forminator-col forminator-col-12">
                    <div className="forminator-field">
                        <label htmlFor="forminator-field-consent-1_react" className="forminator-label">
                            Consent <span className="forminator-required">*</span>
                        </label>
                        <div className="forminator-checkbox__wrapper">
                            <label htmlFor="forminator-field-consent-1_react" className="forminator-checkbox forminator-consent">
                                <input
                                    type="checkbox"
                                    name="consent"
                                    checked={formData.consent}
                                    onChange={handleChange}
                                    id="forminator-field-consent-1_react"
                                    value="checked" // Value when checked
                                    aria-required="true"
                                    required
                                />
                                <span className="forminator-checkbox-box" aria-hidden="true"></span>
                            </label>
                            <div className="forminator-checkbox__label forminator-consent__label">
                                <p>Yes, I agree with the <Link rel="noopener noreferrer" target="_blank" to="#">privacy policy</Link> and <a rel="noopener noreferrer" target="_blank" href="#">terms and conditions</a>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Hidden fields - include if necessary for your logic */}
            {/* <input type="hidden" name="referer_url" value="" /> */}
            <div className="forminator-row forminator-row-last">
                <div className="forminator-col">
                    <div className="forminator-field">
                        <button type="submit" className="forminator-button forminator-button-submit">Submit</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default FeeForm;